import { render, staticRenderFns } from "./platform2.vue?vue&type=template&id=4936e28e&scoped=true"
import script from "./platform2.vue?vue&type=script&lang=js"
export * from "./platform2.vue?vue&type=script&lang=js"
import style0 from "./platform2.vue?vue&type=style&index=0&id=4936e28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4936e28e",
  null
  
)

export default component.exports